<template>
  <b-card
    class="overflow-hidden"
    no-body
  >
    <!-- Vista móvil: tarjetas -->
    <div
      v-if="isSmallScreen"
      class="income-cards"
    >
      <div
        v-for="item in income"
        :key="item.id"
        class="income-card"
      >
        <div class="income-card__top">
          <span class="income-card__title">{{ item.description || ('Folio #' + item.folio) }}</span>
          <span class="income-card__amount">${{ item.total_amount | money }}</span>
        </div>
        <div class="income-card__meta">
          <span>{{ item.income_date | date }}</span>
          <span v-if="item.folio">· Folio #{{ item.folio }}</span>
        </div>
        <div class="income-card__actions">
          <b-dropdown
            :id="`inc-${item.id}`"
            size="sm"
            right
            no-caret
            variant="outline-none"
            class="p-0"
          >
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="18" />
            </template>
            <b-dropdown-item :to="{ name: 'editIncome', params: { incomeId: item.id } }">
              {{ $t('edit') }}
            </b-dropdown-item>
            <b-dropdown-item @click="removeIncome(item)">
              <span class="text-danger">{{ $t('delete') }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- Escritorio: tabla -->
    <b-table
      v-else
      :items="income"
      :fields="fields"
      responsive
    >
      <template #cell(folio)="data">
        <div class="text-primary font-weight-bolder">
          #{{ data.value }}
        </div>
      </template>

      <template #cell(total_amount)="data">
        <div>${{ data.value | money }}</div>
      </template>
      <template #cell(income_date)="data">
        <div>{{ data.value | date }}</div>
      </template>

      <template #cell(tools)="data">
        <b-dropdown
          id="dropdown-1"
          size="sm"
          dropright
          no-caret
          variant="outline-none"
        >
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="18"
              color="#000"
            />
          </template>
          <b-dropdown-item
            :to="{ name: 'editIncome', params: { incomeId: data.item.id } }"
          >{{ $t('edit') }}
          </b-dropdown-item>
          <b-dropdown-item @click="removeIncome(data.item)">
            <span class="text-danger">
              {{ $t('delete') }}
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { BTable } from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    BTable,
  },
  props: {
    income: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'folio',
          label: 'Folio',
        },
        {
          key: 'description',
          label: this.$t('description'),
        },
        {
          key: 'total_amount',
          label: this.$t('amount-2'),
        },
        {
          key: 'income_date',
          label: this.$t('date'),
        },
        {
          key: 'tools',
          label: '',
          thStyle: { width: '10%' },
        },
      ],
    }
  },

  computed: {
    ...mapGetters('incomes', ['incomes', 'incomePagination']),
    ...mapGetters('app', ['isSmallScreen']),
  },

  methods: {
    ...mapActions('incomes', ['deleteIncome', 'fetchIncomes']),
    removeIncome(income) {
      this.deleteIncome(income.id).then(() => {
        this.fetchIncomes({
          projectId: this.$route.params.projectId,
          pagination: this.incomePagination,
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.income-card {
  border-bottom: 1px solid #eceaf1;
  padding: 0.85rem 1rem;

  &:last-child {
    border-bottom: 0;
  }
}

.income-card__top {
  align-items: baseline;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
}

.income-card__title {
  color: #111827;
  font-weight: 700;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.income-card__amount {
  color: #067647;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.income-card__meta {
  color: #6b7280;
  font-size: 0.8rem;
  margin-top: 0.35rem;
}

.income-card__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.35rem;
}
</style>
